import { render, staticRenderFns } from "./Warehouses.vue?vue&type=template&id=6fb4b31b&scoped=true"
import script from "./Warehouses.vue?vue&type=script&lang=js"
export * from "./Warehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4b31b",
  null
  
)

export default component.exports